import React, { Fragment } from "react";
import { Formik, Form, Field, FieldArray } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";

import {
    ACL_CREATE_ROLE_URL,
    ACL_EDIT_ROLE_URL
} from "../../config";
import SubmitButton from "../button/SubmitButton";
import CancelButton from "../button/CancelButton";
import {
    showSuccessAlert,
    showErrorAlert,
} from "../../store/actions/alerts";

import TextField from "../formik/TextField";
import Select from "../formik/Select";

import makeApiRequest from "../../utils/axios/new-axios";
import history from "../../store/history";

const useStyles = makeStyles((theme) => ({
    form: {
        display: "flex",
        flexDirection: "column",
        margin: "auto",
        width: "fit-content",
    }
}));

export default function AddEditRoleForm({
    action,
    openModal,
    handleCloseModal,
    initialValues,
    roleId,
}) {

    const dispatch = useDispatch();
    const classes = useStyles();

    // const [perms, setPermissions] = useState([initialValues.permissions]);

    const yupSchema = Yup.object().shape({
        name: Yup.string().trim().required("Name Required!"),
        permissions: Yup.array().min(1, "Permissions Required!").of(
            Yup.object().shape({
                permissionId: Yup.number().min(1).integer().required(),
                type: Yup.number().min(0).max(3).integer().required()
            }).required("Permissions Required!")
        )
    });


    async function handleSubmit(values, { setSubmitting }) {
        setSubmitting(true);

        const reqJson = {
            name: values.name.trim(),
            permissions: values.permissions.map(p => ({
                permissionId: p.permissionId,
                type: p.type
            }))
        };

        await makeApiRequest({
            url:
                action === "add"
                    ? ACL_CREATE_ROLE_URL.url
                    : `${ACL_EDIT_ROLE_URL.url}/${roleId}`,
            method:
                action === "add"
                    ? ACL_CREATE_ROLE_URL.method
                    : ACL_EDIT_ROLE_URL.method,
            data: reqJson,
        })
            .then((response) => {
                dispatch(showSuccessAlert(`Role ${reqJson.name} ${action === "add" ? "created" : "updated"} successfully`));
                history.push(`/acl/roles`);
            })
            .catch((error) => {
                setSubmitting(false);
                dispatch(
                    showErrorAlert(
                        "Error : " +
                        (!!error.response
                            ? `${error.response.status}! - ${error.response.data.errorMessage}`
                            : error.message)
                    )
                );
            });

        setSubmitting(false);
    }

    return (
        <Dialog
            open={openModal}
            onClose={handleCloseModal}
            fullWidth={true}
            maxWidth="sm"
            aria-labelledby="role-dialog-add-edit"
            aria-describedby="role-dialog-add-edit"
            disableBackdropClick={true}
            disableEscapeKeyDown={true}
            disableEnforceFocus={true}
        >
            <DialogTitle id="role-dialog-title">
                {action === "add" ? "Add" : "Edit"} Admin Role
            </DialogTitle>
            <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                validationSchema={yupSchema}
            >
                {(props) => {
                    const { touched, errors, isSubmitting, values } = props;
                    return (
                        <Form className={classes.form}>
                            <DialogContent dividers style={{ overflow: "visible" }}>
                                <Field
                                    component={TextField}
                                    name="name"
                                    margin="dense"
                                    label="Permission Name"
                                    fullWidth
                                    helperText={touched.name && errors.name && errors.name}
                                    error={!!touched.name && !!errors.name}
                                    disabled={isSubmitting}
                                    autoFocus
                                />
                                <h3>Permissions</h3>
                                {/* <ErrorMessage name="permissions" >
                                    {msg => <div style={{ color: 'red' }}>{msg}</div>}
                                </ErrorMessage> */}
                                <FieldArray
                                    name="permissions"
                                    render={arrayHelpers => {
                                        const perms = values.permissions;
                                        return (
                                            <Fragment>
                                                {perms && perms.length > 0
                                                    && perms.map((p, i) => (
                                                        <Fragment key={i}>
                                                            <div style={{ display: "none" }}>
                                                                <Field name={`permissions.${i}.permissionId`} value={p.permissionId} enabled={false} />
                                                            </div>
                                                            <Field
                                                                component={Select}
                                                                name={`permissions[${i}].type`}
                                                                label={p.permissionName}
                                                                fullWidth
                                                                options={[
                                                                    {
                                                                        value: 0,
                                                                        label: "-- None --",
                                                                    },
                                                                    {
                                                                        value: 1,
                                                                        label: "View",
                                                                    },
                                                                    {
                                                                        value: 2,
                                                                        label: "View & Edit",
                                                                    },
                                                                    {
                                                                        value: 3,
                                                                        label: "View, Edit & Delete",
                                                                    },
                                                                ]}
                                                                disabled={isSubmitting}
                                                            />
                                                        </Fragment>

                                                    ))}
                                            </Fragment>
                                        )
                                    }}
                                />
                                {/* {perms.map((p, i) => {
                                    return (
                                        <Fragment>
                                            <Field name={`permissions[${i}].permissionId`} component={TextField} value={p.permissionId} />
                                            <Field
                                                component={Select}
                                                name={`permissions[${i}].type`}
                                                label={p.permissionName}
                                                fullWidth
                                                options={[
                                                    {
                                                        value: 0,
                                                        label: "-- None --",
                                                    },
                                                    {
                                                        value: 1,
                                                        label: "View",
                                                    },
                                                    {
                                                        value: 2,
                                                        label: "View & Edit",
                                                    },
                                                    {
                                                        value: 3,
                                                        label: "View, Edit & Delete",
                                                    },
                                                ]}
                                                disabled={isSubmitting}
                                            />
                                        </Fragment>
                                    )
                                })} */}


                            </DialogContent>
                            <DialogActions style={{ margin: "20px" }}>
                                <CancelButton
                                    onClick={handleCloseModal}
                                    disabled={isSubmitting}
                                >
                                    Cancel
                                </CancelButton>
                                <SubmitButton
                                    disabled={isSubmitting}
                                    isSubmitting={isSubmitting}
                                    autoFocus
                                >
                                    {action === "add" ? "Add" : "Update"}
                                </SubmitButton>
                            </DialogActions>
                        </Form>
                    );
                }}
            </Formik>
        </Dialog>
    )
}
